import { createAction, props } from "@ngrx/store";
import { ShedulerTaskType } from "./scheduler.state";

export const addTask = createAction(
    '[Scheduler] Add task to scheduler',
    props<{
        task: () => Promise<void>,
        taskType: ShedulerTaskType
    }>()
);

export const addTasks = createAction(
    '[Scheduler] Add tasks to scheduler',
    props<{
        tasks: (() => Promise<void>)[],
        taskType: ShedulerTaskType
    }>()
);

export const startRunnig = createAction(
    '[Scheduler] Start running tasks',
    props<{
        taskType: ShedulerTaskType
    }>()
);

export const executeTask = createAction(
    '[Scheduler] Execute task',
    props<{
        taskType: ShedulerTaskType
    }>()
);

export const executeTaskFinished = createAction(
    '[Scheduler] Execute task finished',
    props<{
        taskType: ShedulerTaskType
    }>()
);

export const stopRunnig = createAction(
    '[Scheduler] Stop running tasks',
    props<{
        taskType: ShedulerTaskType
    }>()
);
